// LoadProgressCard — the one purple progress pill shared by every avatar-load
// indicator (AvatarLoadOverlay for boot, SplatLoadingOverlay for env-apply) so
// they look identical. Top-center fixed pill: title + %, gradient bar (or an
// indeterminate stripe when the total is unknown), a live status line, and an
// optional dimmer subtitle. Presentational only — no store coupling.
import React from 'react'

// Shared accent so every bar matches (was: hair purple vs splat cyan).
export const ACCENT = '#8b6cff'
export const ACCENT_DEEP = '#6c4cff'

export default function LoadProgressCard({ title, fraction = 0, statusLine, subtitle, indeterminate = false, testId }) {
  const pct = Math.round(Math.max(0, Math.min(1, fraction)) * 100)
  return (
    <div data-testid={testId} style={{
      position: 'fixed', top: 18, left: '50%', transform: 'translateX(-50%)',
      zIndex: 99999, pointerEvents: 'none', width: 340, maxWidth: '80%',
      background: 'rgba(12,14,21,0.92)', border: '1px solid #2a2c36',
      borderRadius: 8, padding: '12px 16px', boxShadow: '0 8px 28px rgba(0,0,0,.55)',
      fontFamily: 'var(--m-font)', color: '#e1e1ed',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 8 }}>
        <span style={{ fontSize: 12, letterSpacing: '.04em' }}>{title}</span>
        <span style={{ fontSize: 13, fontWeight: 700, color: ACCENT }}>{indeterminate ? '' : `${pct}%`}</span>
      </div>
      <div style={{
        width: '100%', height: 8, borderRadius: 4, overflow: 'hidden', position: 'relative',
        background: '#0a0c12', border: '1px solid #1f2129',
      }}>
        {indeterminate ? (
          <div style={{
            position: 'absolute', inset: 0,
            background: `linear-gradient(90deg, transparent 0%, ${ACCENT} 50%, transparent 100%)`,
            backgroundSize: '40% 100%', animation: 'aos-load-stripe 1.2s linear infinite',
          }} />
        ) : (
          <div style={{
            width: `${Math.max(3, pct)}%`, height: '100%',
            background: `linear-gradient(90deg, ${ACCENT_DEEP}, ${ACCENT})`,
            transition: 'width 0.3s ease-out',
          }} />
        )}
      </div>
      {statusLine ? (
        <div style={{ marginTop: 6, fontSize: 10, color: '#c7c7d6', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {statusLine}
        </div>
      ) : null}
      {subtitle ? (
        <div style={{ marginTop: 2, fontSize: 9.5, color: '#8f8fa2' }}>{subtitle}</div>
      ) : null}
      <style>{`@keyframes aos-load-stripe { from { background-position: -40% 0; } to { background-position: 140% 0; } }`}</style>
    </div>
  )
}

// Shared byte formatter (kept here so overlays don't each redefine it).
export function fmtSize(bytes) {
  const units = ['B', 'KB', 'MB', 'GB']
  let n = Number(bytes) || 0, i = 0
  while (n >= 1024 && i < units.length - 1) { n /= 1024; i++ }
  return `${n.toFixed(n >= 10 || i === 0 ? 0 : 1)} ${units[i]}`
}
